import React, { useEffect, useRef } from 'react'

// Styles
import Button from '../button'
import Typography from '../typography'
import { FeaturedSliderStyle } from './style'

import featuredSliderStaticQuery from './featuredSliderStaticQuery'
// Components

function getScrollPercent() {
  const scrolledAmount =
    window.pageYOffset ||
    document.scrollingElement?.scrollTop ||
    document.documentElement?.scrollTop ||
    document.body?.scrollTop ||
    0

  const scrollableAmount =
    (document.documentElement?.scrollHeight || document.body?.scrollHeight) -
    document.documentElement?.clientHeight

  return (scrolledAmount / scrollableAmount) * 100
}

const FeaturedSlider = (props: any) => {
  if (props) {
    const modalRef = useRef<HTMLDivElement>(null)

    const handleOpen = () => {
      if (modalRef && modalRef.current) {
        modalRef.current.classList.add('FeaturedSlider--Visible')
      }
    }
    const handleClose = () => {
      if (modalRef && modalRef.current) {
        modalRef?.current?.classList.remove('FeaturedSlider--Visible')
        sessionStorage.setItem('featuredSliderClosed', 'true')
      }
    }

    useEffect(() => {
      document.addEventListener('scroll', e => {
        if (getScrollPercent() >= 10) {
          if (!sessionStorage?.getItem('featuredSliderClosed')) {
            handleOpen()
          }
        }
      })
    }, [])

    let nameId = props.featuredSliderData
      ? props.featuredSliderData.featuredSliderData
      : featuredSliderStaticQuery.allContentfulComponentFeaturedSlider()
          .allContentfulComponentFeaturedSlider.edges

    const listOfIds = nameId.map((item: any, i: number) => {
      return nameId[i]
    })

    let targeted
    for (let i = 0; i < listOfIds.length; i++) {
      if (props.featuredSliderData) {
        nameId[i] = nameId[i]
        targeted = listOfIds[i]?.targetedLinks?.fields?.targetedPages
      } else {
        nameId[i] = nameId[i]?.node
        targeted = listOfIds[i]?.node?.targetedLinks?.targetedPages
      }
      const ShowFeatureSliderPopUp =
        new Date(nameId[i]?.unpublishDate) > new Date() ||
        new Date() < new Date(nameId[i]?.publishDate)

      if (ShowFeatureSliderPopUp) {
        for (let page = 0; page < targeted.length; page++) {
          let slugDetail = props.featuredSliderData
            ? targeted[page]?.fields?.slug
            : targeted[page]?.slug

          let location = props.location ? props.location : targeted[page]

          if (location.pathname === '/' + slugDetail) {
            return (
              <FeaturedSliderStyle
                ref={modalRef}
                data-cy="FeaturedSlider"
                className={nameId[i]?.alignment ? 'leftSide' : 'rightSide'}>
                <div>
                  <Typography className="FeaturedSlider__Headline" type="header5">
                    {nameId[i]?.title}
                  </Typography>
                  <Typography className="FeaturedSlider__Subheadline" type="bodyXS">
                    {nameId[i]?.subtitle}
                  </Typography>
                  <Button
                    href={nameId[i]?.cta?.externalUrl}
                    text={nameId[i]?.cta?.name}
                    icon={true}
                    type="secondary"
                    theme="light"
                  />
                </div>

                <svg
                  width="18"
                  height="18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className="FeaturedSlider__Close-Icon"
                  data-cy="FeaturedSlider__Close-Icon"
                  onClick={handleClose}>
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.293.293a1 1 0 1 1 1.414 1.414L10.414 9l7.293 7.293a1 1 0 0 1-1.414 1.414L9 10.414l-7.293 7.293a1 1 0 0 1-1.414-1.414L7.586 9 .293 1.707A1 1 0 0 1 1.707.293L9 7.586 16.293.293Z"
                    fill="#fff"
                  />
                </svg>
              </FeaturedSliderStyle>
            )
          }
        }
      }
    }
  }
  return null
}

export default FeaturedSlider
